// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1fCsm","dcLogo":"Header_dcLogo__11nTx","dcOneLogo":"Header_dcOneLogo__I1iRe","bannerContainer":"Header_bannerContainer__2fJ8R","show":"Header_show__1qo3z"};